module.exports = __webpack_public_path__ + "static/fp-about-fsri-f89e92b4508e513ecc50fab1fec3af0a.jpg";